import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';

import NavBar from '../components/NavBar';
import FrTextInput from '../components/FrTextInput';
import UserOptions from '../components/UserOptions';
import FrSelect from '../components/FrSelect';
import FrLoading from '../components/FrLoading';
import FrDatePicker from '../components/FrDatePicker'

import api from '../services/api';
import { paramsToObject } from '../utils/functions';
import {colors} from '../utils/vars';

import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';

const swal = withReactContent(Swal)

function RegCursos(props) {
  const [data, setData] = useState({})
  const [updateType, setUpdateType] = useState(false)
  const [enableEdit, setEnableEdit] = useState('N')
  const [comboTme, setComboTme] = useState([{ value: '', display: '' }])
  const [comboCid, setComboCid] = useState([{ value: '', display: '' }])

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
      
      setComboTme(await api.getComboData('tipo_mensalidade'))
      setComboCid(await api.getComboData('cidades'))

      if (query.codigo > 0) {
        setEnableEdit(await api.getAcessos('Cursos', 'Alteracao'))
      } else {
        setEnableEdit(await api.getAcessos('Cursos', 'Inclusao'))
      }

      if (query.codigo > 0) {
        setUpdateType(true)
        api.get('/cursos?pk_cur=' + query.codigo).then(r => {
          if (r.data[0]) {
            console.log(r.data[0])
            setData(r.data[0])
            swal.close()
          } else {
            swal.fire('Código inválido', 'Código informado não encontrado!', 'warning')
              .then((result) => {
                if (result.value) {
                  window.history.back()
                }
              })
          }
        })
      } else swal.close()
    }

    fetchData()
  }, [])

  function consistData(data) {
    let required = [
      'titulo',
      'descricao',
      'fk_tme'
    ]

    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr
      if(fieldName == 'fk_tme') {fieldName = 'Tipo Mensalidade'}
      
      if (!data[curr]) return errors.push(fieldName)
    })

    return errors
  }

  function handleSubmit(e) {
    e.preventDefault();
    swal.fire({
      title: 'ATENÇÃO',
      text: "Deseja salvar " + (updateType ? 'as alterações' : 'a inclusão') + ' do registro?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        const auxValues = { ...data };
        auxValues.data_inicio = auxValues.data_inicio.split("T")[0]
        auxValues.data_fim = auxValues.data_fim.split("T")[0]
        let errors = consistData(auxValues)
        console.log(errors.length)
        if (errors.length === 0) {
          if (updateType) {
            api.post('/cursos/edit', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: 'Registro Alterado',
                  text: "O registro foi alterado com sucesso!",
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: 'Erro!',
                  text: "O registro não foi alterado!",
                  icon: 'warning',
                })
              }
            })
          } else {
            api.post('/cursos/add', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: 'Registro Adicionado',
                  text: "O registro foi adicionado com sucesso!",
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: 'Erro!',
                  text: "O registro não foi adicionado!",
                  icon: 'warning',
                })
              }
            })
          }
        } else {
          swal.fire({
            title: 'Erro!',
            text: "Verifique o(s) campo(s) " + errors.join(','),
            icon: 'warning',
          })
        }
      }
    })
  }

  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
      html: `<p style='color: ${colors.info900}'>Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?<p>`,
      icon: 'warning',
      color: colors.info900,
      showCancelButton: true,
      confirmButtonColor: colors.success500,
        cancelButtonColor: colors.danger500,
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        window.history.back()
      }
    })
  }

  const handleChange = (e) => {
    const auxValues = { ...data };
    switch (e.target.name) {
      case 'CNPJ':
      default: auxValues[e.target.name] = e.target.value;
    }
    setData(auxValues);
  };

  return (
    <div className="defaultReg">
      <NavBar />
    <div className="defaultRegContent">
        <div className="defaultHeader">
          <h3>{updateType ? 'Edição' : 'Inclusão'} de Cursos</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <br />
        <form id="regForm" onSubmit={handleSubmit}>
          <FrTextInput
            maxLength='50'
            value={data.titulo || ''}
            onChange={handleChange}
            name="titulo"
            id="titulo"
            color="#333333"
            label="Título"
            variant="outlined"
            size="small"
            required
            style={{ width: 330 }}
          />
          <FrDatePicker
            name="data_inicio"
            id="data_inicio"
            color="#389492"
            label="Data Início"
            variant="outlined"
            size="small"
            style={{ width: 180 }}
            value={(data.data_inicio || '').split("T")[0]}
            onChange={handleChange}
          />
          <FrDatePicker
            name="data_fim"
            id="data_fim"
            color="#389492"
            label="Data Fim"
            variant="outlined"
            size="small"
            style={{ width: 180 }}
            value={(data.data_fim || '').split("T")[0]}
            onChange={handleChange}
          />
          <br/>

          <FrTextInput
            maxLength='1000'
            value={data.descricao || ''}
            onChange={handleChange}
            name='descricao'
            id='descricao'
            color='#389492'
            label='Descrição'
            variant="outlined"
            size='small'
            required
            style={{ width: 800 }}
            multiline
            rows="10"
            rowsMax="10"
            fullWidth
          />
          <br/>

          <FrTextInput
            maxLength='50'
            value={data.qtd_parcelas || ''}
            onChange={handleChange}
            name="qtd_parcelas"
            id="qtd_parcelas"
            color="#333333"
            label="Quantidade Parcelas"
            variant="outlined"
            size="small"
            required
            style={{ width: 180 }}
          />

          <FrSelect
            value={data.ativo || ''}
            onChange={handleChange}
            name="ativo"
            id="ativo"
            label='Ativo'
            data={[{ display: 'Sim', value: 'S' }, { display: 'Não', value: 'N' }]}
            style={{ width: 150 }}
          />
          
          {/* <FrSelect
            value={data.fk_tme || ''}
            onChange={handleChange}
            name="fk_tme"
            id="fk_tme"
            label='Tipo Mensalidade'
            data={comboTme}
            style={{ width: 290 }}
          /> */}
          <FrTextInput
            maxLength='50'
            value={data.local || ''}
            onChange={handleChange}
            name="local"
            id="local"
            color="#333333"
            label="Local"
            variant="outlined"
            size="small"
            required
            style={{ width: 230 }}
          />
          <FrSelect
            value={data.fk_cid || ''}
            onChange={handleChange}
            name="fk_cid"
            id="fk_cid"
            label='Cidade'
            data={comboCid}
            style={{ width: 250 }}
          />
          <br/>

          <div>
           Inscrição
           <br/>
            <FrTextInput
              maxLength='50'
              value={data.inscricao_socio || ''}
              onChange={handleChange}
              name="inscricao_socio"
              id="inscricao_socio"
              color="#333333"
              label="Inscrição Sócio"
              variant="outlined"
              size="small"
              required
              style={{ width: 230, marginTop: 8 }}
            />
            <FrTextInput
              maxLength='50'
              value={data.inscricao_geral || ''}
              onChange={handleChange}
              name="inscricao_geral"
              id="inscricao_geral"
              color="#333333"
              label="Inscrição Geral"
              variant="outlined"
              size="small"
              required
              style={{ width: 230, marginTop: 8 }}
            />
          </div>

          <div>
           Mensalidade
           <br/>
          <FrTextInput
            maxLength='50'
            value={data.mensalidade_socio || ''}
            onChange={handleChange}
            name="mensalidade_socio"
            id="mensalidade_socio"
            color="#333333"
            label="Mensalidade Sócio"
            variant="outlined"
            size="small"
            required
            style={{ width: 230, marginTop: 8 }}
          />

          
          
          <FrTextInput
            maxLength='50'
            value={data.mensalidade_geral || ''}
            onChange={handleChange}
            name="mensalidade_geral"
            id="mensalidade_geral"
            color="#333333"
            label="Mensalidade Geral"
            variant="outlined"
            size="small"
            required
            style={{ width: 230, marginTop: 8 }}
          />
          </div>

        </form>
        <div className="regButtonsDiv">
          {enableEdit === 'S' ?
            (<button onClick={handleSubmit}>Salvar</button>) : (<></>)}
          <button onClick={handleCancel}>{enableEdit === 'S' ? 'Cancelar' : 'Fechar'}</button>
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default RegCursos;